import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API } from "../APICalls";

export default function Raffles(){


    document.getElementsByTagName("body")[0].classList.remove("login-page");
    document.getElementsByTagName("body")[0].classList.add("sidebar-mini");



    const[raffles, setRaffles] = useState([]);

    useEffect(() => {

        API.GetAllRaffles().then((response) => {
            if(response.ok){
                response.json().then((data) => {
                    setRaffles(data);
                });
            }
            else{
                alert("Token is not valid");
            }
        })
        .catch(() =>
        {
            alert("Cannot connect to LebenRaffle API");
        })

    }, []);

    return (

        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Todos los Sorteos</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item active">Todos los sorteos</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </div>
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div class="card-header">
                                    <h3 class="card-title">Lista de sorteos</h3>
                                </div>
                                <div className="card-body">
                                    <table id="rafflesTable" className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th># Premio(s)</th>
                                                <th># Participantes</th>
                                                <th>Procesado</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {raffles.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{item.Name}</td>
                                                    <td>{item.WinnerNumber} + {item.BenchNumber}</td>
                                                    <td>{item.ParticipantNumber}</td>
                                                    <td>
                                                        {item.RaffleDatetime == null ? (
                                                            <b>No</b>
                                                        ) : (
                                                            <b>Sí</b>
                                                        ) }
                                                    </td>
                                                    <td>
                                                        <Link to={"/raffle/" + item.Id} className="btn btn-primary">Ver</Link>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}